import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b67d9a7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "process-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "process-header__logo" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "process-header__txt1"
}
const _hoisted_4 = { class: "process-header__txt1" }
const _hoisted_5 = { class: "process-content" }
const _hoisted_6 = { class: "process-content__flex" }
const _hoisted_7 = { class: "process-content__text" }
const _hoisted_8 = { class: "process-content__media" }
const _hoisted_9 = { class: "media-item--btm" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "图片", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-yinpin" }, null, -1))
const _hoisted_12 = { class: "media-item--btm" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "音频", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-shipin" }, null, -1))
const _hoisted_15 = { class: "media-item--btm" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "视频", -1))
const _hoisted_17 = {
  key: 0,
  class: "dialog-medias"
}
const _hoisted_18 = {
  key: 0,
  class: "dialog-medias1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElImageViewer = _resolveComponent("ElImageViewer")!
  const _component_MediaList = _resolveComponent("MediaList")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["process-system", { 'process-merchant': _ctx.info.processType=='merchant' }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.info.processType!='merchant')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "受理网点：" + _toDisplayString(_ctx.acceptSite), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.momentFormat(_ctx.info.processingTime, "YYYY-MM-DD HH:mm:ss")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.info.handlingSpeech), 1),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.info.pictureList&&_ctx.info.pictureList.length>0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "media-item",
                  style: _normalizeStyle({ 'background-image': 'url(' + _ctx.thumb + ')' }),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handlePicture(_ctx.info.pictureList)))
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createTextVNode(_toDisplayString(_ctx.info.pictureList.length) + " ", 1),
                    _hoisted_10
                  ])
                ], 4))
              : _createCommentVNode("", true),
            (_ctx.info.audioList&&_ctx.info.audioList.length>0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "media-item",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleAudio(_ctx.info.audioList)))
                }, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createTextVNode(_toDisplayString(_ctx.info.audioList.length), 1),
                    _hoisted_13
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.info.videoList&&_ctx.info.videoList.length>0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "media-item",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleVideo(_ctx.info.videoList)))
                }, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createTextVNode(_toDisplayString(_ctx.info.videoList.length), 1),
                    _hoisted_16
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 2),
    (_ctx.preview.show)
      ? (_openBlock(), _createBlock(_component_ElImageViewer, {
          key: 0,
          "url-list": _ctx.preview.urls,
          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
          onClose: _ctx.onClosePreview
        }, null, 8, ["url-list", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_CommonDialog, {
      title: "音频",
      width: "600px",
      hasFooter: false,
      visible: _ctx.audioDialog.show,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.audioDialog.show) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.audioDialog.show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(_component_MediaList, {
                appId: _ctx.appId,
                type: "audio",
                originFiles: _ctx.audioDialog.urls,
                readOnly: ""
              }, null, 8, ["appId", "originFiles"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_CommonDialog, {
      title: "视频",
      width: "780px",
      hasFooter: false,
      visible: _ctx.videoDialog.show,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.videoDialog.show) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.videoDialog.show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createVNode(_component_MediaList, {
                appId: _ctx.appId,
                type: "video",
                originFiles: _ctx.videoDialog.urls,
                readOnly: ""
              }, null, 8, ["appId", "originFiles"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}